import axios from "@/axios.js"

export default {
    async getIntegratedSchools() {
        const results = await Promise.all([
            axios.get('/api/v2/common/middle_school_info'),
            axios.get('/api/v2/common/high_school_info')
        ])
        results.forEach(res => { if (res.data.result !== 'success') throw res })
        return { data: { data_list: results.flatMap((res, index) => (res.data.data_list || []).map(s => ({ ...s, school_type: index === 0 ? 2 : 3 }))) } }
    },
    previewSchoolExamDrafts(context, payload) {
        return axios.post('/api/v4/exam/school_exam_draft/preview', payload).then(response => {
            if (response.data.result !== 'success') throw response
            return response
        })
    },
    createSchoolExamDraft(context, payload) {
        const form = new FormData()
        form.append('file', payload.file)
        form.append('school_type', payload.school_type)
        return axios.post('/api/v4/exam/school_exam_draft', form).then(response => {
            if (response.data.result !== 'success') throw response
            return response
        })
    },
    getSchoolExamNewList(context, school_type) {
        return new Promise((resolve, reject) => {
            axios.get(`/api/v4/exam/school_exam_list?school_type=${school_type}`)
                .then((response) => {
                    if (response.data.result == 'success') {
                        resolve(response)
                    }
                    reject(response)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },
    createSchoolExamNew(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post('/api/v4/exam/school_exam', payload)
                .then((response) => {
                    if (response.data.result == 'success') {
                        resolve(response)
                    }
                    reject(response)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },
    updateSchoolExamNew(context, payload) {
        return new Promise((resolve, reject) => {
            axios.put('/api/v4/exam/school_exam', payload)
                .then((response) => {
                    if (response.data.result == 'success') {
                        resolve(response)
                    }
                    reject(response)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },
    deleteSchoolExamNew(context, id) {
        return new Promise((resolve, reject) => {
            axios.delete(`/api/v4/exam/school_exam?id=${id}`)
                .then((response) => {
                    if (response.data.result == 'success') {
                        resolve(response)
                    }
                    reject(response)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },
    getSchoolExamNewDetail(context, id) {
        return new Promise((resolve, reject) => {
            axios.get(`/api/v4/exam/school_exam?id=${id}`)
                .then((response) => {
                    if (response.data.result == 'success') {
                        resolve(response)
                    }
                    reject(response)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },
    getSchoolExamPrice(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(`/api/v4/exam/school_exam_price?grade_id=${payload.grade_id}&subject_type_id=${payload.subject_type_id}&subject_detail_type_id=${payload.subject_detail_type_id || ''}&subject_code=${encodeURIComponent(payload.subject_code || '')}`)
                .then((response) => {
                    if (response.data.result == 'success') {
                        resolve(response)
                    }
                    reject(response)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },
    getSubjectMaster() {
        return new Promise((resolve, reject) => {
            axios.get('/api/v2/common/subject_master')
                .then((response) => {
                    if (response.data.result == 'success') {
                        resolve(response)
                    }
                    reject(response)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },
    uploadSchoolExamNewFile(context, payload) {
        var frm = new FormData()
        frm.append("id", payload.id)
        frm.append("type", payload.type)
        frm.append("file", payload.file)
        return new Promise((resolve, reject) => {
            axios.put("/api/v4/exam/school_exam_file", frm, { headers: { 'Content-Type': 'multipart/form-data' } })
                .then((response) => {
                    if (response.data.result == 'success') {
                        resolve(response)
                    }
                    reject(response)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }
}
